const removeHTML = htmlText => {
  return htmlText
        .replace(/(<([^>]+)>)/ig, '')
        .replace('[&hellip;]', '...')
        .replace(/&nbsp;/g, ' ')
}

module.exports = removeHTML
